// client.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private baseUrl = environment.baseUrlApi;

  constructor(private http: HttpClient) { }

  // Add a new client
  addClient(clientData: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/add-clients`, clientData);
  }

  // Get a list of clients with pagination and search
  getListClients(perPage: number, page: number, search: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/clients`, {
      params: {
        perPage: perPage.toString(),
        page: page.toString(),
        search: search
      }
    });
  }

  // Get client details by ID
  getClientById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/clients/${id}`);
  }

  // Update client details
  updateClient(id: number, clientData: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/clients/${id}`, clientData);
  }

  // Remove a client by ID
  removeClientById(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/clients/${id}`);
  }

  getAllClientEmails() {
    const url = environment.baseUrlApi + "/admin/emails";
    return this.http.get(url);
  }

  sendBulkEmails(emails: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/admin/send-emails`, { emails });
  }
  

  uploadExcel(formData: FormData): Observable<any> {
    const apiUrl = environment.baseUrlApi + "/upload-excel"; // Remplacez par votre URL de backend
    return this.http.post<any>(apiUrl, formData, {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      })
    });
  }

  getAvailableTimeSlots(clientId?: number) {
    let url = `${this.baseUrl}/appointments/available-time-slots`;
    if (clientId) {
      url += `?client_id=${clientId}`;
    }
    return this.http.get<any[]>(url);
  }
  
  createAppointment(data: any) {
    return this.http.post(`${this.baseUrl}/appointments`, data);
  }

  getAppointments(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/appointments`);
  }

  // Supprimer un rendez-vous par id
deleteAppointment(id: number): Observable<any> {
  return this.http.delete(`${this.baseUrl}/appointments/${id}`);
}

hasAppointment(clientId: number): Observable<{ hasAppointment: boolean }> {
  return this.http.get<{ hasAppointment: boolean }>(`${this.baseUrl}/clients/${clientId}/has-appointment`);
}

  
}

